












































































import { Watch, Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Project } from '@/api/model/project'
const projects = namespace('projects')

@Component
export default class ProjectsList extends Vue {
    @projects.State readonly loading!: boolean
    @projects.State readonly projects!: Project[]
    @projects.State readonly totalItems!: number
    @projects.State readonly totalPages!: number
    @projects.State readonly page!: number
    @projects.State readonly orderField!: string|null
    @projects.State readonly orderDirection!: string|null
    @projects.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @projects.Action nextPage: () => Promise<void>
    @projects.Action prevPage: () => Promise<void>
    @projects.Action applyOrder: ({ field, direction }) => Promise<void>

    created() {
        this.onRouteChange()
    }

    @Watch('$route')
    async onRouteChange(): Promise<void> {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
    }

    async goToProjectsDetail(project: Project): Promise<void> {
        await this.$router.push({
            name: 'projects_detail',
            params: {
                projectId: project.id,
            },
        })
    }

    async goToProjectsCreate(): Promise<void> {
        await this.$router.push({
            name: 'projects_create',
        })
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }
}
